import { render, staticRenderFns } from "./CheckDB.vue?vue&type=template&id=0b50bbd4&scoped=true"
import script from "./CheckDB.vue?vue&type=script&lang=js"
export * from "./CheckDB.vue?vue&type=script&lang=js"
import style0 from "./CheckDB.vue?vue&type=style&index=0&id=0b50bbd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50bbd4",
  null
  
)

export default component.exports